var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "consume-edit"
  }, [_c('style-bar', {
    staticClass: "mb-2",
    attrs: {
      "css-keys": ['background', 'color'],
      "mode": "text",
      "styles": _vm.localStyles
    },
    on: {
      "update:styles": function updateStyles($event) {
        _vm.localStyles = $event;
      }
    }
  }), _c('div', {
    staticClass: "py-2 px-4 form-ctn"
  }, [_c('div', {
    staticClass: "font-weight-light",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('consumeedit_note'))
    }
  }), _c('v-radio-group', {
    on: {
      "input": function input($event) {
        return _vm.updateMode();
      }
    },
    model: {
      value: _vm.form.mode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "mode", $$v);
      },
      expression: "form.mode"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('automatic'),
      "value": "auto"
    }
  }), _c('span', {
    staticClass: "font-weight-light pl-8 pb-2"
  }, [_vm._v(_vm._s(_vm.$t('consumeedit_automatic_description')))]), _c('v-radio', {
    attrs: {
      "label": _vm.$t('manual'),
      "value": "manual"
    }
  }), _c('span', {
    staticClass: "font-weight-light pl-8 pb-2"
  }, [_vm._v(_vm._s(_vm.$t('consumeedit_manual_description')))])], 1), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.form.mode == 'manual',
      expression: "form.mode == 'manual' "
    }],
    staticClass: "pl-8 pt-0",
    attrs: {
      "placeholder": _vm.$t('consumeedit_consume_now_placeholder'),
      "label": _vm.$t('consumeedit_consume_button_label')
    },
    on: {
      "input": function input($event) {
        return _vm.updateButton();
      }
    },
    model: {
      value: _vm.form.consumeBtn,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "consumeBtn", $$v);
      },
      expression: "form.consumeBtn"
    }
  }), _c('rich-text-input', {
    attrs: {
      "content": _vm.form.content,
      "mode": "textarea",
      "json": _vm.editorContentJson,
      "label": _vm.$t('consumeedit_description_before')
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.form, "content", $event);
      },
      "update:json": function updateJson($event) {
        _vm.editorContentJson = $event;
      }
    }
  }), _c('rich-text-input', {
    attrs: {
      "content": _vm.form.consumedContent,
      "mode": "textarea",
      "json": _vm.editorConsumedContentJson,
      "label": _vm.$t('consumeedit_description_after')
    },
    on: {
      "update:content": function updateContent($event) {
        return _vm.$set(_vm.form, "consumedContent", $event);
      },
      "update:json": function updateJson($event) {
        _vm.editorConsumedContentJson = $event;
      }
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }